<template>
  <div class="design_home">
    <div class="design_home_background">
      <design_1_block/>
      <design_2_block/>
    </div>
    <our_services/>
    <design_3_block/>
  </div>
</template>

<script>
import design_1_block from '@/components/design/design_1_block.vue'
import design_2_block from '@/components/design/design_2_block.vue'
import design_3_block from '@/components/design/design_3_block.vue'
import our_services from '@/components/our_services.vue'
export default {
  name: 'Home',
  components: {
    design_1_block,
    design_2_block,
    design_3_block,
    our_services,
  }
};
</script>

<style scoped>
.design_home_background {
  position:relative;
  z-index: 1;
}
.design_home_background:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 135%;
    background: linear-gradient(180deg,#2a1061 -.03%,#1b0b3d 99.97%);
    transform: skewY(6deg);
    z-index: 0;
    top: -300px;
}
@media (max-width:950px) {
  .design_home_background:before {
    height: 130%;
  }
}
@media (max-width:950px) {
  .design_home_background:before {
    height: 130%;
  }
}
@media (max-width:767px) {
  .design_home_background:before {
    height: 116%;
  }
}
@media (max-width:502px) {
  .design_home_background:before {
    height: 114%;
  }
}
</style>